import React from "react";

import { TableBody, TableCell, TableRow } from "./Table";

type LoadingProps = {
  colSpan: number;
};

type EmptyProps = {
  colSpan: number;
  label: string;
};

type EmptyStateProps = {
  label: string;
};

export const LoadingState = () => (
  <div className="flex items-center justify-center py-8">
    <div className="text-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#113F67] mx-auto mb-2"></div>
      <p className="text-sm text-gray-500">લોડ થઈ રહ્યું છે...</p>
    </div>
  </div>
);

export const EmptyState = ({ label }: EmptyStateProps) => (
  <div className="text-center py-8">
    <p className="text-gray-500">{label}</p>
  </div>
);

export const TableLoadingRow = ({ colSpan }: LoadingProps) => (
  <TableBody>
    <TableRow>
      <TableCell colSpan={colSpan}>
        <LoadingState />
      </TableCell>
    </TableRow>
  </TableBody>
);

export const TableEmptyRow = ({ colSpan, label }: EmptyProps) => (
  <TableBody>
    <TableRow>
      <TableCell colSpan={colSpan}>
        <EmptyState label={label} />
      </TableCell>
    </TableRow>
  </TableBody>
);
